<!--
  功能：T0策略详情页
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2026-07-20 13:38:40
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="yulan-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
        <div>
            <div class="header-bg">
                <van-sticky z-index="100">
                    <div
                        class="content-nav-bar"
                        :class="bodyOffsetTop <= contentNavBar ? 'sticky-header' : ''"
                        :style="`backdrop-filter: blur(${filterNum}px)`"
                    >
                        <van-nav-bar>
                            <template #left>
                                <van-icon name="arrow-left" size="18" @click="goBack" />
                            </template>
                            <template #title>
                                <div class="title-flex">
                                    <span class="nav-title">策略详情</span>
                                    <img
                                        class="nav-title-tag"
                                        src="@/assets/image/t0/T0Tag.png"
                                        alt="T0"
                                    />
                                </div>
                            </template>
                        </van-nav-bar>
                    </div>
                </van-sticky>
                <!-- 策略名称/跳转按钮 -->
                <div class="header">
                    <div class="title">
                        <span class="name">{{
                            strategyDetail ? strategyDetail.strategyName : '我的T0策略1'
                        }}</span>
                        <div class="edit" @click="goUseStrategy">使用策略</div>
                    </div>
                </div>
                <!-- 内容页面 -->
                <div class="content" ref="body">
                    <!-- 买卖条件 -->
                    <div class="trade-condition">
                        <!-- 买入因子池 -->
                        <div class="factor-pool" v-if="strategyDetail && strategyDetail.buyPool">
                            <!-- 小标题 -->
                            <div class="section-title">
                                <span class="gradient-text">·买入因子池</span>
                            </div>
                            <!-- 容器 -->
                            <div class="factor-container">
                                <!-- 且组/或组 -->
                                <div class="he-group">
                                    <div class="factor-qh-text">
                                        {{
                                            strategyDetail.buyPool.composeType === 'jj'
                                                ? '且'
                                                : '或'
                                        }}
                                    </div>
                                    <div class="factor-list">
                                        <div
                                            class="factor-card"
                                            v-for="(item, index) in strategyDetail.buyPool.yzList"
                                            :key="'buy-yz-' + index + '-' + (item.ID || item.Info || '')"
                                        >
                                            <div class="factor-name">{{ item.FactorName }}</div>
                                            <div class="factor-info">
                                                <template v-if="item.yzType === 0">
                                                    <span
                                                        class="factor-change"
                                                        :class="judgeColor(item.RiZhangFu)"
                                                        >{{ toFixedNum(item.RiZhangFu * 100, 2, '%', true) }}</span
                                                    >
                                                    <span class="factor-count"
                                                        >{{ item.XinHaoShuLiang || 0 }}只</span
                                                    >
                                                </template>
                                                <span class="factor-tag non" v-if="item.isNon"
                                                    >非</span
                                                >
                                                <span
                                                    class="factor-tag t0"
                                                    v-else-if="item.yzType === 70"
                                                    >事件</span
                                                >
                                            </div>
                                        </div>
                                        <!-- 或组/且组（嵌套） -->
                                        <template
                                            v-for="(childGroup, groupIndex) in strategyDetail
                                                .buyPool.children"
                                        >
                                            <div
                                                class="huo-group"
                                                :key="'buy-child-' + groupIndex"
                                                v-if="childGroup && childGroup.length > 0"
                                            >
                                                <div class="factor-qh-text">
                                                    {{
                                                        strategyDetail.buyPool.composeType === 'jj'
                                                            ? '或'
                                                            : '且'
                                                    }}
                                                </div>
                                                <div class="factor-list">
                                                    <div
                                                        class="factor-card"
                                                        v-for="(
                                                            childItem, childIndex
                                                        ) in childGroup"
                                                        :key="'buy-child-card-' + groupIndex + '-' + childIndex + '-' + (childItem.ID || childItem.Info || '')"
                                                    >
                                                        <div class="factor-name">
                                                            {{ childItem.FactorName }}
                                                        </div>
                                                        <div class="factor-info">
                                                            <template v-if="childItem.yzType === 0">
                                                                <span class="factor-change" :class="judgeColor(childItem.RiZhangFu)">{{ toFixedNum(childItem.RiZhangFu * 100, 2, '%', true) }}</span>
                                                                <span class="factor-count"
                                                                    >{{
                                                                        childItem.XinHaoShuLiang ||
                                                                        0
                                                                    }}只</span
                                                                >
                                                            </template>
                                                            <span
                                                                class="factor-tag non"
                                                                v-if="childItem.isNon"
                                                                >非</span
                                                            >
                                                            <span
                                                                class="factor-tag t0"
                                                                v-else-if="childItem.yzType === 70"
                                                                >事件</span
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- 小标题 -->
                            <div class="section-title">
                                <span class="gradient-text">· 买入后何时卖出</span>
                            </div>
                            <!-- 卖出条件 -->
                            <div class="sell-condition">
                                <div class="sell-condition-shadow">
                                    <img src="@/assets/image/t0/ellipse.svg" alt="" />
                                </div>
                                <div class="condition-row">
                                    <span class="condition-label">到期卖出</span>
                                    <span class="condition-value">收盘集合竞价卖出</span>
                                </div>
                                <div
                                    class="condition-row"
                                    v-if="strategyDetail && strategyDetail.buyProfitPct"
                                >
                                    <span class="condition-label">止盈卖出</span>
                                    <span class="condition-value"
                                        >买入后股价上涨{{ strategyDetail.buyProfitPct }}%卖出</span
                                    >
                                </div>
                                <div
                                    class="condition-row"
                                    v-if="strategyDetail && strategyDetail.buyLossPct"
                                >
                                    <span class="condition-label">止损卖出</span>
                                    <span class="condition-value"
                                        >买入后股价下跌{{ strategyDetail.buyLossPct }}%卖出</span
                                    >
                                </div>
                            </div>
                        </div>
                        <!-- 卖出因子池 -->
                        <div class="factor-pool" v-if="strategyDetail && strategyDetail.sellPool">
                            <!-- 小标题 -->
                            <div class="section-title">
                                <span class="gradient-text">·卖出因子池</span>
                            </div>
                            <!-- 容器 -->
                            <div class="factor-container">
                                <!-- 且组/或组 -->
                                <div class="he-group">
                                    <div class="factor-qh-text">
                                        {{
                                            strategyDetail.sellPool.composeType === 'jj'
                                                ? '且'
                                                : '或'
                                        }}
                                    </div>
                                    <div class="factor-list">
                                        <div
                                            class="factor-card"
                                            v-for="(item, index) in strategyDetail.sellPool.yzList"
                                            :key="'sell-yz-' + index + '-' + (item.ID || item.Info || '')"
                                        >
                                            <div class="factor-name">{{ item.FactorName }}</div>
                                            <div class="factor-info">
                                                <template v-if="item.yzType === 0">
                                                    <span class="factor-change" :class="judgeColor(item.RiZhangFu)">{{ toFixedNum(item.RiZhangFu * 100, 2, '%', true) }}</span>
                                                    <span class="factor-count"
                                                        >{{ item.XinHaoShuLiang || 0 }}只</span
                                                    >
                                                </template>
                                                <span class="factor-tag non" v-if="item.isNon"
                                                    >非</span
                                                >
                                                <span
                                                    class="factor-tag t0"
                                                    v-else-if="item.yzType === 70"
                                                    >事件</span
                                                >
                                            </div>
                                        </div>
                                        <!-- 或组/且组（嵌套） -->
                                        <template
                                            v-for="(childGroup, groupIndex) in strategyDetail
                                                .sellPool.children"
                                        >
                                            <div
                                                class="huo-group"
                                                :key="'sell-child-' + groupIndex"
                                                v-if="childGroup && childGroup.length > 0"
                                            >
                                                <div class="factor-qh-text">
                                                    {{
                                                        strategyDetail.sellPool.composeType === 'jj'
                                                            ? '或'
                                                            : '且'
                                                    }}
                                                </div>
                                                <div class="factor-list">
                                                    <div
                                                        class="factor-card"
                                                        v-for="(
                                                            childItem, childIndex
                                                        ) in childGroup"
                                                        :key="'sell-child-card-' + groupIndex + '-' + childIndex + '-' + (childItem.ID || childItem.Info || '')"
                                                    >
                                                        <div class="factor-name">
                                                            {{ childItem.FactorName }}
                                                        </div>
                                                        <div class="factor-info">
                                                            <template v-if="childItem.yzType === 0">
                                                                <span class="factor-change" :class="judgeColor(childItem.RiZhangFu)">{{ toFixedNum(childItem.RiZhangFu * 100, 2, '%', true) }}</span>
                                                                <span class="factor-count"
                                                                    >{{
                                                                        childItem.XinHaoShuLiang ||
                                                                        0
                                                                    }}只</span
                                                                >
                                                            </template>
                                                            <span
                                                                class="factor-tag non"
                                                                v-if="childItem.isNon"
                                                                >非</span
                                                            >
                                                            <span
                                                                class="factor-tag t0"
                                                                v-else-if="childItem.yzType === 70"
                                                                >事件</span
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <!-- 小标题 -->
                            <div class="section-title">
                                <span class="gradient-text">· 买入后何时卖出</span>
                            </div>
                            <!-- 卖出条件 -->
                            <div class="sell-condition">
                                <div class="sell-condition-shadow">
                                    <img src="@/assets/image/t0/ellipse.svg" alt="" />
                                </div>
                                <div class="condition-row">
                                    <span class="condition-label">到期卖出</span>
                                    <span class="condition-value">收盘集合竞价卖出</span>
                                </div>
                                <div
                                    class="condition-row"
                                    v-if="strategyDetail && strategyDetail.buyProfitPct"
                                >
                                    <span class="condition-label">止盈卖出</span>
                                    <span class="condition-value"
                                        >买入后股价上涨{{ strategyDetail.buyProfitPct }}%卖出</span
                                    >
                                </div>
                                <div
                                    class="condition-row"
                                    v-if="strategyDetail && strategyDetail.buyLossPct"
                                >
                                    <span class="condition-label">止损卖出</span>
                                    <span class="condition-value"
                                        >买入后股价下跌{{ strategyDetail.buyLossPct }}%卖出</span
                                    >
                                </div>
                            </div>
                        </div>
                        <!-- 交易参数 -->
                        <div class="factor-pool" v-if="strategyDetail">
                            <!-- 小标题 -->
                            <div class="section-title">
                                <span class="gradient-text gradient-color-black">· 交易参数</span>
                            </div>
                            <!-- 参数列表 -->
                            <div class="trade-params">
                                <div class="param-item">
                                    <div class="param-label">
                                        <span>单次交易比例</span>
                                        <van-icon name="question-o" class="help-icon" @click="showHelpToast('信号触发时买/卖股票数量占底仓数量百分比')" />
                                    </div>
                                    <div class="param-value">{{ strategyDetail.singleTradeRatio || 20 }}%</div>
                                </div>
                                <div class="param-item">
                                    <div class="param-label">
                                        <span>最小信号间隔</span>
                                        <van-icon name="question-o" class="help-icon" @click="showHelpToast('防止信号过于频繁')" />
                                    </div>
                                    <div class="param-value">{{ strategyDetail.signalIntervalMinutes || 10 }}分钟</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 调仓记录 -->
                <div class="rebalance-record">
                    <!-- 标题 -->
                    <div class="record-title">
                        <span>调仓记录</span>
                    </div>
                    <!-- 内容 -->
                    <van-list
                        v-model="signalLoading"
                        :finished="signalFinished"
                        @load="onLoadSignalList"
                    >
                        <div class="record-content" v-if="signalList && signalList.length > 0">
                            <!-- 时间列 -->
                            <div class="record-col time-col">
                                <div class="col-header">
                                    <span>时间</span>
                                </div>
                                <div class="col-item" v-for="(item, index) in signalList" :key="'time-' + index">
                                    <span>{{ formatSignalTime(item.signalTime) }}</span>
                                </div>
                            </div>
                            <!-- 股票名称列 -->
                            <div class="record-col stock-col">
                                <div class="col-header">
                                    <span>股票名称</span>
                                </div>
                                <div class="col-item" v-for="(item, index) in signalList" :key="'stock-' + index">
                                    <span class="stock-name" @click="gotoStock(item.stockCode)">{{ item.stockName || '-' }}</span>
                                    <span class="stock-code" @click="gotoStock(item.stockCode)">{{ formatStock(item.stockCode) }}</span>
                                </div>
                            </div>
                            <!-- 操作列 + 触发价列 + 信号盈亏列 -->
                            <div class="record-col-right">
                                <!-- 操作列 -->
                                <div class="record-col action-col">
                                    <div class="col-header">
                                        <span>操作</span>
                                    </div>
                                    <div class="col-item" v-for="(item, index) in signalList" :key="'action-' + index">
                                        <span :class="item.direction === '调入' ? 'action-in' : 'action-out'">{{ item.direction || '-' }}</span>
                                    </div>
                                </div>
                                <!-- 触发价列 -->
                                <div class="record-col price-col">
                                    <div class="col-header">
                                        <span>触发价</span>
                                    </div>
                                    <div class="col-item" v-for="(item, index) in signalList" :key="'price-' + index">
                                        <span>{{ item.triggerPrice ? Number(item.triggerPrice).toFixed(2) : '-' }}</span>
                                    </div>
                                </div>
                                <!-- 信号盈亏列 -->
                                <div class="record-col profit-col">
                                    <div class="col-header">
                                        <span>信号盈亏</span>
                                    </div>
                                    <div class="col-item" v-for="(item, index) in signalList" :key="'profit-' + index">
                                        <span :class="judgeColor(item.profitLoss)">{{ toFixedNum(item.profitLoss, 2, '%', true) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-list>
                    <!-- 暂无数据 -->
                    <div class="no-data" v-if="signalFinished && signalList.length === 0">
                        <span>暂无数据</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getStrategyDetail, getSignalList } from '@/api/t0.js';
import { getFactorHq, getStockHq } from '@/api/create.js';
import { judgeColor, toFixedNum, formatStock } from '@/utils/format.js';

export default {
    // 组件名称
    name: 'T0Detail',
    // 组件参数 接收来自父组件的数据
    props: {},
    // 局部注册的组件
    components: {},
    // 组件状态值
    data() {
        return {
            bodyOffsetTop: 0,
            filterNum: 0,
            contentNavBar: 44,
            scrollTop: 0,
            strategyId: null,
            strategyDetail: null,
            factorHqData: {}, // 因子行情数据
            signalList: [], // 调仓记录列表
            signalPage: 1, // 当前页码
            signalPageSize: 10, // 每页条数
            signalTotal: 0, // 总条数
            signalLoading: false, // 加载状态
            signalFinished: false, // 是否加载完毕
            hqList: [] // 实时行情数据
        };
    },
    // 计算属性
    computed: {},
    // 侦听器
    watch: {},
    // 组件方法
    methods: {
        judgeColor,
        toFixedNum,
        formatStock,
        goBack() {
            window.location.href = 'dzh_browser_url&goto=0&screen=263';
        },
        goUseStrategy() {
            window.location.href = 'dzh_browser_url&goto=0&screen=204&id=8009&mask=1';
        },
        // 显示帮助提示
        showHelpToast(message) {
            this.$toast(message);
        },
        // 格式化信号时间（只显示时间部分）
        formatSignalTime(signalTime) {
            if (!signalTime) return '-';
            // signalTime 格式：2026-07-22 16:57:01
            const parts = signalTime.split(' ');
            return parts.length > 1 ? parts[1] : signalTime;
        },
        // 跳转到股票分时
        gotoStock(stockCode) {
            if (!stockCode) return;
            window.location.href = `dzh_browser_url&goto=0&type=2970&code=${stockCode}&kind=1&source=1&direct=1`;
        },
        // 监听 ref=body 的滚动条距离用来控制 header 的背景色显示隐藏
        handleScroll() {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (this.$refs.body) {
                this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
                this.filterNum = (this.scrollTop / (this.bodyOffsetTop / 2)).toFixed(2);
            }
        },
        // 获取策略详情
        fetchStrategyDetail(strategyId) {
            if (!strategyId) return;
            getStrategyDetail({ strategyId })
                .then((res) => {
                    if (res.err === 200) {
                        this.strategyDetail = res.data;
                        console.log('策略详情:', res.data);
                        // 获取因子行情
                        this.fetchFactorHq(res.data);
                        // 获取调仓记录
                        this.fetchSignalList();
                    }
                })
                .catch((err) => {
                    console.error('获取策略详情失败:', err);
                });
        },
        // 提取因子 Info 并获取行情
        fetchFactorHq(strategyData) {
            if (!strategyData) return;
            const yzIds = [];
            // 从 buyPool 中提取 yzType == 0 的因子 Info
            if (strategyData.buyPool && strategyData.buyPool.yzList) {
                strategyData.buyPool.yzList.forEach((item) => {
                    if (item.yzType === 0 && item.Info) {
                        yzIds.push(item.Info);
                    }
                });
            }
            // 从 buyPool.children 中提取
            if (strategyData.buyPool && strategyData.buyPool.children) {
                strategyData.buyPool.children.forEach((group) => {
                    if (group && group.length > 0) {
                        group.forEach((item) => {
                            if (item.yzType === 0 && item.Info) {
                                yzIds.push(item.Info);
                            }
                        });
                    }
                });
            }
            // 从 sellPool 中提取
            if (strategyData.sellPool && strategyData.sellPool.yzList) {
                strategyData.sellPool.yzList.forEach((item) => {
                    if (item.yzType === 0 && item.Info) {
                        yzIds.push(item.Info);
                    }
                });
            }
            // 从 sellPool.children 中提取
            if (strategyData.sellPool && strategyData.sellPool.children) {
                strategyData.sellPool.children.forEach((group) => {
                    if (group && group.length > 0) {
                        group.forEach((item) => {
                            if (item.yzType === 0 && item.Info) {
                                yzIds.push(item.Info);
                            }
                        });
                    }
                });
            }
            // 去重并逗号分隔
            const uniqueYzIds = [...new Set(yzIds)].filter((id) => id).join(',');
            if (!uniqueYzIds) return;
            // 调用行情接口
            this.getFactorHqFun(uniqueYzIds);
        },
        // 获取因子行情
        getFactorHqFun(yzIds) {
            var params = {
                type: 'yz',
                factorID: yzIds,
                field: 'Desc,LongTouGu,KanDian,FactorCode,zhangdietongji,XiFenZhongLei'
            };
            getFactorHq(params)
                .then((res) => {
                    if (res.err === 200) {
                        // 将数组转换为以 ID 为 key 的对象
                        const hqData = {};
                        if (Array.isArray(res.data)) {
                            res.data.forEach((item) => {
                                if (item.ID) {
                                    hqData[item.ID] = item;
                                }
                            });
                        }
                        this.factorHqData = hqData;
                        console.log('因子行情数据:', this.factorHqData);
                        // 将行情数据一一对应到策略详情中
                        this.mergeHqData();
                    }
                })
                .catch((err) => {
                    console.error('获取因子行情失败:', err);
                });
        },
        // 合并行情数据到策略详情
        mergeHqData() {
            if (!this.strategyDetail || !this.factorHqData) return;
            // 合并 buyPool 数据
            this.mergePoolHq(this.strategyDetail.buyPool);
            // 合并 sellPool 数据
            this.mergePoolHq(this.strategyDetail.sellPool);
        },
        // 合并单个因子池的行情数据
        mergePoolHq(pool) {
            if (!pool) return;
            // 合并 yzList
            if (pool.yzList) {
                pool.yzList.forEach((item, index) => {
                    // 使用 Info 匹配行情数据中的 ID
                    if (item.Info && this.factorHqData[item.Info]) {
                        const hqItem = this.factorHqData[item.Info];
                        // 替换数据：保留原有字段，用行情数据覆盖
                        this.$set(pool.yzList, index, {
                            ...item,
                            RiZhangFu: hqItem.RiZhangFu,
                            XinHaoShuLiang: hqItem.XinHaoShuLiang,
                            XiFenZhongLei: hqItem.XiFenZhongLei,
                            LongTouGu: hqItem.LongTouGu,
                            Desc: hqItem.Desc,
                            FactorCode: hqItem.FactorCode,
                            KanDian: hqItem.KanDian
                        });
                    }
                });
            }
            // 合并 children
            if (pool.children) {
                pool.children.forEach((group, groupIndex) => {
                    if (group && group.length > 0) {
                        const newGroup = group.map((item) => {
                            // 使用 Info 匹配行情数据中的 ID
                            if (item.Info && this.factorHqData[item.Info]) {
                                const hqItem = this.factorHqData[item.Info];
                                return {
                                    ...item,
                                    RiZhangFu: hqItem.RiZhangFu,
                                    XinHaoShuLiang: hqItem.XinHaoShuLiang,
                                    XiFenZhongLei: hqItem.XiFenZhongLei,
                                    LongTouGu: hqItem.LongTouGu,
                                    Desc: hqItem.Desc,
                                    FactorCode: hqItem.FactorCode,
                                    KanDian: hqItem.KanDian
                                };
                            }
                            return item;
                        });
                        // 使用 Vue.set 确保响应式更新
                        this.$set(pool.children, groupIndex, newGroup);
                    }
                });
            }
        },
        // 获取调仓记录（初始化）
        fetchSignalList() {
            if (!this.strategyId) return;

            // 重置分页状态
            this.signalList = [];
            this.signalPage = 1;
            this.signalTotal = 0;
            this.signalLoading = false;
            this.signalFinished = false;

            // 加载第一页
            this.onLoadSignalList();
        },
        // 下拉加载调仓记录
        onLoadSignalList() {
            // 如果已经加载完毕，直接返回
            if (this.signalFinished) {
                this.signalLoading = false;
                return;
            }

            // 设置加载状态
            this.signalLoading = true;

            // 获取今日日期 yyyy-MM-dd
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const signalDate = `${yyyy}-${mm}-${dd}`;

            const params = {
                strategyId: this.strategyId,
                page: this.signalPage,
                pageSize: this.signalPageSize,
                signalDate,
                orderBy: 'signal_time',
                orderDir: 'DESC'
            };

            getSignalList(params)
                .then((res) => {
                    if (res.err === 200) {
                        const list = (res.data && res.data.list) || [];
                        this.signalTotal = (res.data && res.data.total) || 0;

                        // 追加数据
                        this.signalList = this.signalList.concat(list);
                        console.log('调仓记录:', res.data);

                        // 判断是否加载完毕
                        if (this.signalList.length >= this.signalTotal) {
                            this.signalFinished = true;
                        }

                        // 页码 +1
                        this.signalPage++;

                        // 获取实时行情
                        this.getStockHqFun();
                    }
                    this.signalLoading = false;
                })
                .catch((err) => {
                    console.error('获取调仓记录失败:', err);
                    this.signalLoading = false;
                });
        },
        // 获取实时行情
        getStockHqFun() {
            if (!this.signalList || this.signalList.length === 0) return;

            // 提取股票代码
            const stockCodes = [];
            this.signalList.forEach((item) => {
                if (item.stockCode && !stockCodes.includes(item.stockCode)) {
                    stockCodes.push(item.stockCode);
                }
            });

            if (stockCodes.length === 0) return;

            const params = {
                stockID: stockCodes.toString()
            };

            getStockHq(params)
                .then((res) => {
                    if (res.err === 200) {
                        this.hqList = res.data || {};
                        console.log('实时行情:', this.hqList);
                        // 计算信号盈亏
                        this.calcProfitLoss();
                    }
                })
                .catch((err) => {
                    console.error('获取实时行情失败:', err);
                });
        },
        // 计算信号盈亏
        calcProfitLoss() {
            if (!this.signalList || this.signalList.length === 0) return;

            // hqList 是对象格式，key 为股票代码
            const hqMap = this.hqList || {};

            // 遍历信号列表，计算盈亏
            this.signalList = this.signalList.map((item) => {
                const hq = hqMap[item.stockCode];
                const latestPrice = hq ? (hq.ZuiXinJia || 0) : 0;
                const triggerPrice = item.triggerPrice || 0;

                let profitLoss = 0;
                if (triggerPrice > 0 && latestPrice > 0) {
                    if (item.direction === '调入') {
                        // 调入：(最新价 - 触发价格)/触发价格*100%
                        profitLoss = ((latestPrice - triggerPrice) / triggerPrice) * 100;
                    } else if (item.direction === '调出') {
                        // 调出：(触发价格 - 最新价)/触发价格*100%
                        profitLoss = ((triggerPrice - latestPrice) / triggerPrice) * 100;
                    }
                }

                return {
                    ...item,
                    profitLoss: profitLoss,
                    latestPrice: latestPrice
                };
            });
        }
    },
    // 以下是生命周期钩子   注：没用到的钩子请自行删除
    /**
     * 在实例初始化之后，组件属性计算之前，如data属性等
     */
    beforeCreate() {},
    /**
     * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
     */
    created() {
        // 检测路由中是否存在 strategyId
        this.strategyId = this.$route.query.strategyId || this.$route.params.strategyId;
        if (this.strategyId) {
            this.fetchStrategyDetail(this.strategyId);
        }
    },
    /**
     * 在挂载开始之前被调用：相关的 render 函数首次被调用。
     */
    beforeMount() {},
    /**
     * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
     * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
     */
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        if (this.$refs.body) {
            this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
        }
    },
    /**
     * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
     * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
     */
    beforeUpdate() {},
    /**
     * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
     * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
     */
    updated() {},
    /**
     * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
     */
    activated() {},
    /**
     * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
     */
    deactivated() {},
    /**
     * 实例销毁之前调用。在这一步，实例仍然完全可用。
     */
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    /**
     * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
     * 所有的事件监听器会被移除，所有的子实例也会被销毁。
     */
    destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->

<style lang="less" scoped>
.yulan-info {
    .title-flex {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
    }
    .nav-title {
        font-weight: 500;
        font-size: 16px;
        color: #222;
        vertical-align: middle;
    }
    .nav-title-tag {
        height: 16px;
        margin-left: 4px;
        vertical-align: middle;
    }

    // 导航栏背景效果
    .content-nav-bar {
        transition: background-color 0.3s ease;
        &.sticky-header {
            background-color: rgba(255, 255, 255, 0.8);
        }
    }

    .header-bg {
        // height: 100vh;
    }

    .content {
        // height: calc(100vh - 152px);
        // overflow-y: auto;
        // overflow-x: hidden;
        padding: 0 12px;
    }

    // 买卖条件
    .trade-condition {
        padding-bottom: 12px;
    }

    // 因子池
    .factor-pool {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        padding: 10px 12px 12px;
        margin-bottom: 8px;
    }

    // 小标题
    .section-title {
        margin-bottom: 8px;
        .gradient-text {
            font-weight: bold;
            font-size: 14px;
            line-height: 22.4px;
            background: linear-gradient(-90deg, #286df7 0%, #158fff 90.476%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
        .gradient-color-black {
            background: linear-gradient(-90deg, #373A4D 0%, #373A4D 90.476%);
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
    }

    // 因子容器
    .factor-container {
        margin-bottom: 8px;
        background: rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(5px);
        border-radius: 8px;
        padding: 10px;
    }

    // 且组（外层）
    .he-group {
        position: relative;
        padding-left: 17px;
        border-left: 1px solid rgba(59, 133, 254, 1);
        border-radius: 10px;

        // 且文字按钮 靠左居中
        .factor-qh-text {
            position: absolute;
            left: -9px;
            top: 50%;
            transform: translateY(-50%);
            background: #c6d8fd;
            border-radius: 4px;
            padding: 4px 2px;
            color: #286df7;
            font-size: 14px;
            font-weight: 500;
        }
    }

    // 或组（内层）
    .huo-group {
        margin-top: 10px;
        position: relative;
        padding-left: 15px;
        border-left: 1px solid #3b85fe;
        border-radius: 10px;

        // 或文字按钮 靠左居中
        .factor-qh-text {
            position: absolute;
            left: -9px;
            top: 50%;
            transform: translateY(-50%);
            background: #c6d8fd;
            border-radius: 4px;
            padding: 4px 2px;
            color: #286df7;
            font-size: 14px;
            font-weight: 500;
        }

        .factor-list {
            .factor-card:last-child {
                margin-bottom: 0;
            }
        }
    }

    // 因子列表
    .factor-list {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    // 因子卡片
    .factor-card {
        background: #ffffff;
        border-radius: 6px;
        padding: 6px 10px;
        display: flex;
        align-items: center;

        .factor-name {
            width: 35%;
            font-weight: 500;
            font-size: 14px;
            color: #222;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .factor-info {
            width: 65%;
            background: rgba(0, 0, 0, 0.02);
            border-radius: 4px;
            padding: 2px 12px;
            height: 24px;
            display: flex;
            align-items: center;
            gap: 4px;
            padding-right: 0px;

            .factor-change {
                font-weight: 600;
                font-size: 12px;
                width: 80px;

                &.red {
                    color: #ef3939;
                }

                &.green {
                    color: #1eac4e;
                }

                &.gray {
                    color: #999;
                }
            }

            .factor-count {
                font-size: 12px;
                color: #555;
                width: 65px;
            }

            .factor-tag {
                background: rgba(40, 109, 247, 0.08);
                border: 0.8px solid #286df7;
                border-radius: 4px;
                padding: 0.8px 4px;
                font-size: 10px;
                font-weight: 600;
                color: #286df7;
                height: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: auto;
            }

            .factor-tag.non {
                font-size: 12px;
                line-height: 9.6px;
            }
            .factor-tag.t0 {
                width: 35px;
            }
        }
    }

    // 卖出条件
    .sell-condition {
        background: #fff;
        border: 1px solid #fff;
        border-radius: 6px;
        padding: 16px 18px;
        position: relative;
        overflow: hidden;

        // 左上角阴影效果
        .sell-condition-shadow {
            position: absolute;
            top: 0;
            left: 0;
            width: 55px;
            height: 56px;
            pointer-events: none;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }

        .condition-row {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-bottom: 4px;

            &:last-child {
                margin-bottom: 0;
            }

            .condition-label {
                font-size: 12px;
                color: #666;
                width: 48px;
                flex-shrink: 0;
            }

            .condition-value {
                font-weight: 500;
                font-size: 12px;
                color: rgba(55, 58, 77, 0.9);
            }
        }
    }

    // 交易参数
    .trade-params {
        display: flex;
        gap: 4px;
        margin-top: 4px;

        .param-item {
            flex: 1;
            background: #fff;
            border-radius: 6px;
            padding: 10px 12px;
            min-width: 0;

            .param-label {
                display: flex;
                align-items: center;
                gap: 4px;
                margin-bottom: 2px;

                span {
                    font-size: 12px;
                    color: #666;
                }

                .help-icon {
                    width: 14px;
                    height: 14px;
                    flex-shrink: 0;
                    color: #99A3B8;
                }
            }

            .param-value {
                font-weight: 500;
                font-size: 16px;
                color: #373a4d;
            }
        }
    }

    // 调仓记录
    .rebalance-record {
        background: #fff;
        border-radius: 8px;
        margin-top: 8px;
        overflow: hidden;

        // 标题
        .record-title {
            background: #fff;
            padding: 8px 16px;
            span {
                font-weight: 600;
                font-size: 16px;
                color: rgba(55, 58, 77, 0.9);
            }
        }

        // 内容
        .record-content {
            display: flex;
            background: #fff;

            // 列通用样式
            .record-col {
                display: flex;
                flex-direction: column;

                .col-header {
                    padding: 4px 16px;
                    height: 25px;
                    display: flex;
                    align-items: center;
                    span {
                        font-size: 12px;
                        color: #999;
                    }
                }

                .col-item {
                    height: 50px;
                    display: flex;
                    align-items: center;
                    padding: 7px 6px;
                    span {
                        font-size: 12px;
                        color: #373a4d;
                    }
                }
            }

            // 时间列
            .time-col {
                .col-header,
                .col-item {
                    padding-left: 16px;
                    justify-content: flex-start;
                }
                .col-item span {
                    text-align: right;
                }
            }

            // 股票名称列
            .stock-col {
                width: 100px;
                .col-item {
                    flex-direction: column;
                    align-items: flex-start;
                    padding-left: 15px;
                    .stock-name {
                        font-weight: 600;
                        font-size: 14px;
                        color: #373a4d;
                        line-height: 19.6px;
                        cursor: pointer;
                        &:hover {
                            color: #286df7;
                        }
                    }
                    .stock-code {
                        font-size: 12px;
                        color: #999;
                        line-height: 16.8px;
                        margin-top: 4px;
                        cursor: pointer;
                        &:hover {
                            color: #286df7;
                        }
                    }
                }
            }

            // 右侧列容器
            .record-col-right {
                display: flex;
                gap: 5px;

                // 操作列
                .action-col {
                    width: 60px;
                    .col-header {
                        justify-content: center;
                        padding: 4px 16px;
                    }
                    .col-item {
                        justify-content: center;
                        padding: 10px 6px;
                        .action-out {
                            font-size: 14px;
                            color: #1eac4e;
                        }
                        .action-in {
                            font-size: 14px;
                            color: #ef3939;
                        }
                    }
                }

                // 触发价列
                .price-col {
                    width: 60px;
                    .col-header {
                        justify-content: center;
                        padding: 4px 6px;
                    }
                    .col-item {
                        justify-content: center;
                        padding: 7px 6px;
                    }
                }

                // 信号盈亏列
                .profit-col {
                    width: 70px;
                    .col-header {
                        justify-content: flex-end;
                        padding-right: 6px;
                    }
                    .col-item {
                        justify-content: flex-end;
                        padding: 7px 6px;
                        span {
                            text-align: right;
                        }
                        .profit-up {
                            font-size: 12px;
                            color: #ef3939;
                        }
                        .profit-down {
                            font-size: 12px;
                            color: #1eac4e;
                        }
                    }
                }
            }
        }

        // 暂无数据
        .no-data {
            background: #fff;
            padding: 40px 16px;
            text-align: center;

            span {
                font-size: 14px;
                color: #999;
            }
        }
    }

    .header {
        padding: 20px 16px;
        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
                font-weight: 500;
                font-size: 20px;
                color: #222;
            }
            .edit {
                width: 84px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                font-weight: 500;
                font-size: 14px;
                color: #fff;
                border-radius: 17px;
                background: #286df7;
            }
        }
    }
    .collapse {
        padding: 0 16px 22px 16px;
        .title {
            font-weight: 700;
            font-size: 14px;
            color: #286df7;
        }
        .yz-list {
            .li {
                height: 34px;
                line-height: 34px;
                border: 1px solid #fff;
                border-radius: 4px;
                background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
                padding: 0 12px;
                margin-top: 6px;
                font-weight: 500;
                font-size: 12px;
                color: rgba(55, 58, 77, 0.9);
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
            }
        }
    }
    .btm-style {
        border-radius: 8px 8px 0 0;
        background: #fff;
        padding-bottom: 80px;
    }
    .yulan-content {
        .van-tabs {
            border-radius: 8px 8px 0 0;
            overflow: hidden;
        }
        ::v-deep {
            .van-tab {
                font-weight: 400;
                font-size: 14px;
                color: #373a4d;
            }
            .van-tab--active {
                font-weight: 600 !important;
                font-size: 14px !important;
                color: #286df7 !important;
            }
            .van-tabs__line {
                background: #286df7;
            }
        }
    }
    .bottom-btn {
        position: fixed;
        bottom: 34px;
        width: 100%;
        padding: 0 18.5px;
        z-index: 9;
        button {
            width: 100%;
        }

        .hcBtn {
            border: none;
            height: 40px;
            border-radius: 20px;
            padding: 0px 16px;
            background: #fff;
            border: 1px solid #286df7;
            color: #286df7;
            flex-shrink: 0;
            margin-right: 8px;
        }
        .clBtn {
            border: none;
            height: 40px;
            border-radius: 20px;
            padding: 0px 16px;
            background: #286df7;
            border: 1px solid #286df7;
            color: #fff;
            width: 100%;
        }
        .btn_class {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    ::v-deep {
        .van-overlay {
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 100;
            .wrapper-overlay {
                width: 285px;
                border-radius: 10px;
                padding: 16px;
                background: #fff;
                .wrapper-title {
                    text-align: center;
                    font-size: 16px;
                    color: #222;
                    margin-bottom: 16px;
                }
                .wrapper-label {
                    font-size: 14px;
                    color: #555;
                    margin-bottom: 4px;
                }
                .name {
                    position: relative;
                    .van-cell {
                        height: 38px;
                        padding: 8px 10px;
                    }
                    .van-field__word-limit {
                        position: absolute;
                        right: 7px;
                        top: 0px;
                    }
                }
                .van-cell {
                    border: 0.5px solid #e5e5e5;
                    border-radius: 4px;
                    margin-bottom: 16px;
                    padding: 8px 10px;
                    &::after {
                        border: none;
                    }
                }
                .van-field__control {
                    &::placeholder {
                        font-size: 14px;
                    }
                }
            }
            .wrapper-btn {
                display: flex;
                align-items: center;
                justify-content: space-between;
                button {
                    border: none;
                    height: 36px;
                    font-size: 14px;
                    border-radius: 6px;
                    width: 50%;
                }
                .left {
                    background: #f5f5f6;
                    color: #222;
                    margin-right: 12px;
                }
                .rught {
                    background: #286df7;
                    color: #fff;
                    margin-left: 12px;
                }
            }
        }
    }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
    .yulan-content {
        .name,
        .title {
            color: #e4e9fe !important;
        }
        .yz-list {
            .li {
                border: 1px solid rgba(255, 255, 255, 0.1);
                background: rgba(255, 255, 255, 0.1);
                color: #e4e9fe;
            }
        }
        ::v-deep {
            .btm-style,
            .van-tabs__nav {
                background: #191a24;
            }
            .van-tab {
                color: #e4e9fe;
            }
        }
    }
    .wrapper-overlay {
        background: #181a23 !important;
        .wrapper-title {
            color: #e4e9fe !important;
        }
        .wrapper-label {
            color: #aab9d1 !important;
        }
        .van-cell {
            background: none;
            border: 1px solid #3b3d43 !important;
        }
        ::v-deep {
            .van-field__control {
                color: #e4e9fe !important;
            }
        }
        .wrapper-btn {
            .left {
                background: #46484f;
                color: #aab9d1;
            }
        }
    }
    .hcBtn {
        background: #46484f !important;
        border: 1px solid #46484f !important;
        color: #e4e9fe !important;
    }
    .van-button--disabled {
        background: #25262a !important;
        border: 1px solid #25262a !important;
        color: #e4e9fe !important;
    }
}
</style>
